import { Button } from "primereact/button";
import { useFormContext } from "react-hook-form";

import { SaveStatus } from "./SaveStatus";
import { useSaveStatus } from "./useSaveStatus";

interface IOrderFormHeaderProps {
  title: string;
  accountName?: string;
  onBack?: () => void;
  onCancel?: () => void;
}

export function OrderFormHeader({
  title,
  accountName,
  onBack,
  onCancel,
}: IOrderFormHeaderProps) {
  const form = useFormContext();
  const saveState = useSaveStatus();

  const patientName = [form?.watch("firstName"), form?.watch("lastName")]
    .filter(Boolean)
    .join(" ")
    .trim();

  const subtitle = [patientName, accountName].filter(Boolean).join(" · ");

  return (
    <div
      className="flex flex-wrap align-items-center justify-content-between gap-3 bg-white border-bottom-1 px-4 py-3 mb-4"
      style={{
        borderBottomColor: "var(--brand-gray-200)",
        marginTop: "calc(-1 * var(--content-gap-top))",
        marginLeft: "calc(-1 * var(--content-gutter))",
        marginRight: "calc(-1 * var(--content-gutter))",
      }}
    >
      <div className="flex align-items-center gap-3">
        {!!onBack && (
          <Button
            className="p-button-neutral p-button-sm p-button-rounded-md"
            icon="pi pi-angle-left"
            label="Back"
            onClick={onBack}
          />
        )}

        <div className="flex flex-column">
          <span
            className="text-base font-semibold line-height-2"
            style={{ color: "var(--brand-black)" }}
          >
            {title}
          </span>

          {!!subtitle && (
            <span
              className="text-xs line-height-2"
              style={{ color: "var(--brand-gray-500)" }}
            >
              {subtitle}
            </span>
          )}
        </div>
      </div>

      <div
        data-testid="header"
        className="flex flex-1 align-items-center justify-content-end gap-3"
      >
        <SaveStatus state={saveState} />

        {!!onCancel && (
          <Button
            className="p-button-text p-button-plain p-button-sm"
            label="Cancel"
            onClick={onCancel}
          />
        )}
      </div>
    </div>
  );
}
